import React, { useEffect, useState } from "react";
import CheckoutWizard from "./components/CheckoutWizard";
import OrderStatus from "./components/OrderStatus";
import Footer from "./components/Footer";
import shopLogo from "./images/shopLogo.png";
import "./App.css";
import "@shopify/polaris/build/esm/styles.css";
import { useCheckoutContext } from "./context/CheckoutContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { fetchCart } from "api";
import ReactPixel from "react-facebook-pixel";
import TiktokPixel from "tiktok-pixel";
import Hotjar from "@hotjar/browser";
import { sendErrorToSlack } from "./services/slackService";

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < breakpoint
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

const App = () => {
  const { checkout, setCheckout } = useCheckoutContext();
  const [isLoading, setIsLoading] = useState(true);
  const isMobile = useIsMobile(768);
  const advancedMatching = {};
  if (checkout.customer?.email) {
    advancedMatching.em = checkout.customer?.email;
  }

  // Initialize Facebook Pixel
  ReactPixel.init("1215656903083802", advancedMatching, {
    autoConfig: true,
    debug: false,
  });
  ReactPixel.pageView();
  ReactPixel.fbq("track", "PageView");

  // Initialize TikTok Pixel
  TiktokPixel.init("D28LRG3C77U916NJ1I2G", {
    debug: false,
  });
  TiktokPixel.pageView();

  // Initialize Hotjar
  const siteId = 5217062;
  const hotjarVersion = 6;
  Hotjar.init(siteId, hotjarVersion);

  useEffect(() => {
    const fetchCartData = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const cartToken = params.get("cartToken");
        const shopUrl = params.get("shopUrl");
        const silentLoginToken = params.get("silentLoginToken");
        const referral = params.get("referral");
        const rc = params.get("rc");
        const enrollType = params.get("enrollType");

        const cartData = await fetchCart(
          cartToken,
          shopUrl,
          silentLoginToken,
          referral,
          rc,
          enrollType
        );

        setCheckout((prevCheckout) => {
          return {
            ...prevCheckout,
            cart: { ...prevCheckout.cart, ...cartData.cart },
            shopifyCustomer: {
              ...prevCheckout.shopifyCustomer,
              ...cartData.shopifyCustomer,
            },
            customer: { ...prevCheckout.customer, ...cartData.customer },
            settings: { ...prevCheckout.customer, ...cartData.customSettings },
            cartToken: cartToken,
            orderPoints: cartData.orderPoints,
            shopUrl: shopUrl,
            customerToken: silentLoginToken,
            enrollType: enrollType,
            invalidReferral: referral && cartData.cart?.referral === "No referral" && referral !== "Oola Life",
            originalReferral: referral, 
          };
        });

        if (!cartData.shopifyCustomer) {
          const isEnrollingAsAmbassador = enrollType === "ambassador";
          const isEnrollingAsAffiliate = enrollType === "affiliate";
          
          let customerTypeId = isEnrollingAsAmbassador ? 3 : isEnrollingAsAffiliate ? 6 : 4;

          setCheckout((prevCheckout) => {
            return {
              ...prevCheckout,
              shopifyCustomer: { ...prevCheckout.shopifyCustomer, customerTypeID: customerTypeId },
            };
          });
        }
        

        setIsLoading(false);
      } catch (error) {
        sendErrorToSlack(error, {
          component: "App-FetchCart",
          cartToken: new URLSearchParams(window.location.search).get(
            "cartToken"
          ),
          userEmail: checkout.customer?.email,
        });
        console.error("Error fetching cart:", error);
        setIsLoading(false);
      }
    };

    fetchCartData();
  }, [setCheckout]);

  return (
    <Row className="h-100">
      <Col xs={12} md={6}>
        <div className="mainContainer leftContainer">
          <div className="wrapper marginBottomSmall">
            <img
              src={shopLogo}
              className="mb-3"
              alt="company-logo"
              style={{ maxWidth: "200px", maxHeight: "200px", height: "auto" }}
            />
            {isLoading ? (
              <div>Loading...</div>
            ) : (
              <>
                {isMobile && <OrderStatus cart={checkout.cart} isMobile={true} />}
                <div className="wizardContainer">
                  <CheckoutWizard cart={checkout} />
                </div>
              </>
            )}
            <div className="horizontalRuler marginTopMedium" />
            <Footer />
          </div>
        </div>
      </Col>
      {isLoading ? <div></div> : !isMobile && <OrderStatus cart={checkout.cart} />}
    </Row>
  );
};

export default App;
